const i18nRoutes = {
  "/": "HOME",
  "/home": "HOME",
  "/activity": "ACTIVITY",
  "/settings": "SETTINGS",
  "/settings/security": "SECURITY",
  "/settings/security/password": "PASSWORD",
  "/settings/security/pin": "PIN SETTINGS",
  "/settings/help": "HELP & SUPPORT",
  "/settings/about": "ABOUT",
  "/settings/billing": "BILLING",
  "/settings/members": "MEMBERS",
  "/settings/profile": "PROFILE",
  "/settings/admin": "SUPER ADMIN",
  "/settings/admin/users": "USERS ADMIN",
  "/settings/admin/teams": "TEAMS ADMIN",
  "/settings/admin/clubs": "CLUBS ADMIN",
  "/activity/training-history": "TRAINING HISTORY",

  //VR
  "/coach/editor": "EDITOR",
  "/coach/editor/results": "RESULTS",
  "/admin": "ADMIN",
  "/admin/users": "USERS",
  "/admin/teams": "TEAMS",
  "/admin/clubs": "CLUBS",
  "/settings/admin-stats-clubs": "STATS",
  "/coach": "COACH",
  "/home/scenario-training": "SCENARIO TRAINING",
  "/home/scenario-training/career": "CAREER",
  "/home/scenario-training/career/results": "RESULTS",
  "/home/scenario-training/practise": "PRACTISE",
  "/home/scenario-training/practise/results": "RESULTS",
  "/activity/session/:sessionId": "SESSION RESULTS",
  "/activity/session/:sessionId/result/:resultId": "SCENARIO RESULTS",
  "/home/results": "RESULTS",
  "/home/guides": "GUIDES",
  "/home/purchase": "PURCHASE",
  "/home/matchplay": "MATCHPLAY",
  "/home/playlists": "PLAYLISTS",
  "/home/playlists/details": "PLAYLIST DETAILS",
  "/home/playlists/results": "RESULTS",
  "/updates": "UPDATES",
};

export default i18nRoutes;
